import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Flex, Text, Button } from '@chatsdet/ui';
import { Buildings } from '@phosphor-icons/react';

export type WrongOrgInfo = {
  orgId: string;
  orgName: string;
};

interface OrgSwitchPromptProps {
  resourceType: string;
  targetOrgId: string;
  targetOrgName: string;
  redirectUrl: string;
  onCancel: () => void;
}

export const OrgSwitchPrompt: React.FC<OrgSwitchPromptProps> = ({
  resourceType,
  targetOrgId,
  targetOrgName,
  redirectUrl,
  onCancel,
}) => {
  const { switchOrg, isSwitchingOrg } = useAuth();

  return (
    <Flex direction="column" align="center" justify="center" className="py-16 space-y-4">
      <Buildings size={32} className="text-muted-foreground" />
      <Text size="sm" className="text-center">
        This {resourceType} belongs to <strong className="font-semibold">{targetOrgName}</strong>.
      </Text>
      <Text size="sm" className="text-muted-foreground text-center">
        Would you like to switch to that organization to access it?
      </Text>
      <Flex gap="sm" className="mt-2">
        <Button variant="outline" onPress={onCancel}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onPress={() => switchOrg(targetOrgId, redirectUrl)}
          isDisabled={isSwitchingOrg}
        >
          {isSwitchingOrg ? 'Switching...' : 'Switch Organization'}
        </Button>
      </Flex>
    </Flex>
  );
};
